import axios from '@/utils/request'
var Qs = require('qs')

export default {
	states: ['applying', 'outed', 'rejected', 'ined'],
	// 2021-01-05
	create(params) {
		return axios.post('/mms/allocates', params)
	},
	// 2021-01-06
	search(params) {
		return axios.get('/mms/allocates?' + Qs.stringify(params, { arrayFormat: 'repeat' }));
	},
	// 2021-01-06
	insertBatch(params) {
		return axios.post('/mms/allocates/insert-batch', params)
	},
	// 2021-01-06
	update(id, params) {
		return axios.put('/mms/allocates/' + id, params)
	},
	// 2021-01-06
	delete(id) {
		return axios.delete('/mms/allocates/' + id)
	},
	// 2021-01-06
	acceptStockOut(id, params) {
		return axios.put('/mms/allocates/' + id + '/accept-stock-out', params)
	},
	// 2021-01-06
	reject(id, params) {
		return axios.put('/mms/allocates/' + id + '/reject', params)
	},
	// 2021-01-06
	stockIn(id) {
		return axios.put('/mms/allocates/' + id + '/stock-in')
	},
}

